// Author panyurou
// Date 2023-11-16 16:41:12

import * as model from "@/model/sithMes/stool/SithMesStoolRequireDateChangeHistoryModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolRequireDateChangeHistory(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
